import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';
import { inOrderColumns, pfSortableColumns } from '../constants';

const FilterComponentPF = ({ citizenships, cities, onPropertyChange, filters, counties, countries, specialFilters }) => {
  const [t] = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          id={`browserContainerPJ_filters_name`}
          fullWidth
          label={t('OfferEdit.Client.Name')}
          value={specialFilters.partnerName}
          onChange={value => onPropertyChange(value, 'fullName')}
          inputProps={{
            maxLength: 255
          }}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          id={`browserContainerPJ_filters_id`}
          fullWidth
          label={t('OfferEdit.Client.PersonalIdentifier')}
          value={specialFilters.uniqueId}
          onChange={value => onPropertyChange(value, 'uniqueId')}
          inputProps={{
            maxLength: 255
          }}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={`browserContainerPJ_filters_citizenship`}
          fullWidth
          value={filters.citizenshipId}
          onChange={value => onPropertyChange(value, 'citizenshipId')}
          label={t('OfferEdit.Client.Citizenship')}
          simpleValue
          valueKey={'id'}
          labelKey={'name'}
          options={citizenships}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={`browserContainerPJ_filters_nationality`}
          fullWidth
          value={filters.nationalityId}
          onChange={value => onPropertyChange(value, 'nationalityId')}
          label={t('OfferEdit.Client.Nationality')}
          simpleValue
          valueKey={'id'}
          labelKey={'name'}
          options={citizenships}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <TextField
          id={`browserContainerPJ_filters_series`}
          fullWidth
          label={t('OfferEdit.Client.PassportSeriesAndNumber')}
          value={specialFilters.idSeriesAndNumber}
          onChange={value => onPropertyChange(value, 'idSeriesAndNumber')}
          inputProps={{
            maxLength: 255
          }}
          debounceBy={500}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <DateTime
          name='birthDate'
          value={filters.birthDate}
          timeFormat={false}
          label={t('OfferEdit.Client.BirthDate')}
          onChange={value => onPropertyChange(value, 'birthDate')}
          isClearable
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={`browserContainerPJ_filters_country`}
          fullWidth
          value={filters.countryId}
          onChange={value => onPropertyChange(value, 'countryId')}
          label={t('OfferEdit.Client.Country')}
          simpleValue
          valueKey={'countryId'}
          labelKey={'countryName'}
          options={countries}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={`browserContainerPJ_filters_county`}
          fullWidth
          value={filters.countyId}
          onChange={value => onPropertyChange(value, 'countyId')}
          label={t('OfferEdit.Client.County')}
          simpleValue
          valueKey={'districtId'}
          labelKey={'districtName'}
          options={counties}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={`browserContainerPJ_filters_city`}
          fullWidth
          value={filters.cityId}
          onChange={value => onPropertyChange(value, 'cityId')}
          label={t('OfferEdit.Client.City')}
          simpleValue
          valueKey={'cityId'}
          labelKey={'cityName'}
          options={cities}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={'listFilter_orderByPJ'}
          label={t('Tooltips.OrderBy')}
          valueKey={'id'}
          labelKey={'name'}
          value={filters.orderByColumn}
          onChange={value => onPropertyChange(value, 'orderByColumn')}
          fullWidth
          simpleValue
          options={pfSortableColumns.map(item => {
            return {
              id: item.columnName,
              name: t(item.displayNameKey)
            };
          })}
        />
      </Grid>
      <Grid item xs={12} sm={6} lg={4}>
        <Autocomplete
          id={'listFilter_orderByPJ'}
          label={t('Tooltips.InOrder')}
          valueKey={'id'}
          value={filters.orderByDescending}
          onChange={value => onPropertyChange(value, 'orderByDescending')}
          fullWidth
          simpleValue
          isClearable
          options={inOrderColumns.map(item => {
            return {
              id: item.columnName,
              name: t(item.displayNameKey)
            };
          })}
        />
      </Grid>
    </>
  );
};
FilterComponentPF.propTypes = {
  cities: PropTypes.array.isRequired,
  counties: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  citizenships: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  onColumnChange: PropTypes.func,
  filters: PropTypes.object.isRequired,
  onChangeOrderBy: PropTypes.func,
  onChangeOrderByColumn: PropTypes.func,
  orderByColumn: PropTypes.object,
  specialFilters: PropTypes.object
};

export default FilterComponentPF;
